export default () => ({
  message: null,
  httpStatusCode: null,
  appCode: null,
});
